export default __webpack_public_path__ + "static/media/kitchen_fan.svg";